module.exports = __webpack_public_path__ + "img/Bottomline.6bdc9513.png";